// DTO → form-value helpers shared by every entity form's mapper.

// Always a string: null uncontrols the input, and a number makes isFormDirty read dirty.
export const formValue = (value) => (value == null ? '' : String(value));

// Skips a key the server reads as "unset" instead of sending it empty.
export const appendIfPresent = (formData, key, value) => {
  if (value === undefined || value === null || value === '') return;
  formData.append(key, value);
};
